import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex justify-center gap-2" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", {
    class: "text-sm text-center",
    style: { "color": "#1a576a" }
}, [
    /*#__PURE__*/ _createElementVNode("span", null, "Equazione utilizzata:"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" Clearance della creatinina = (creat. urinaria * diuresi giornaliera / creat. sierica * 1440) ")
], -1);
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import BaseInput from "../components/BaseInput.vue";
import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'creatCalculator',
    props: {
        creatininemia: {}
    },
    setup: function (__props) {
        var props = __props;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var creatininuria = ref();
        var diuresi = ref();
        var clearCreatinina = ref("...");
        var creatininemia = ref();
        var creatininuriaValid = ref(" ");
        var diuresiValid = ref(" ");
        var creatinemiaValid = ref(" ");
        function checkInputValidity() {
            if (creatininuria.value < 40 || creatininuria.value > 200) {
                creatininuriaValid.value =
                    "Controlla il valore inserito. I valori normali sono compresi tra 40 e 200";
            }
            else {
                creatininuriaValid.value = " ";
            }
            if (diuresi.value < 800 || diuresi.value > 2000) {
                diuresiValid.value =
                    "Controlla il valore inserito. I valori normali sono compresi tra 800 e 2000";
            }
            else {
                diuresiValid.value = " ";
            }
            if (creatininemia.value < 0.1 || creatininemia.value > 13) {
                creatinemiaValid.value =
                    "Controlla il valore inserito. I valori sono compresi tra 0.1 e 13";
            }
            else {
                creatinemiaValid.value = " ";
            }
        }
        function eraser(field) {
            field.value = "";
        }
        function resetForm() {
            // Cancella i valori di input
            eraser(creatininemia);
            eraser(creatininuria);
            eraser(diuresi);
            // Cancella i validatori
            eraser(creatinemiaValid);
            eraser(creatininuriaValid);
            eraser(diuresiValid);
            // Cancella il valore calcolato
            clearCreatinina.value = "...";
        }
        function calculator() {
            creatininemia.value = (isNaN(creatininemia.value) || creatininemia.value < 0.1) ? 1 : creatininemia.value;
            creatininuria.value = (isNaN(creatininuria.value) || creatininuria.value < 0.1) ? 40 : creatininuria.value;
            diuresi.value = (isNaN(diuresi.value) || diuresi.value < 0.1) ? 800 : diuresi.value;
            checkInputValidity();
            var VFG = Math.round((creatininuria.value * diuresi.value) / (creatininemia.value * 1440));
            clearCreatinina.value = Math.round(VFG);
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                            label: "Creat. sierica mg/dL",
                            type: "number",
                            placeholder: "1",
                            step: "0.1",
                            lang: "it",
                            modelValue: _unref(creatininemia),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(creatininemia) ? (creatininemia).value = $event : creatininemia = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(creatinemiaValid)
                        }, null, 8, ["modelValue", "isInputValid"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Creat. urinaria mg/dL'),
                            type: "number",
                            placeholder: "40",
                            step: "0.1",
                            lang: "it",
                            modelValue: _unref(creatininuria),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (_isRef(creatininuria) ? (creatininuria).value = $event : creatininuria = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(creatininuriaValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Diuresi giornaliera'),
                            type: "number",
                            placeholder: "800",
                            modelValue: _unref(diuresi),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (_isRef(diuresi) ? (diuresi).value = $event : diuresi = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(diuresiValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"])
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(BaseOutput, {
                            class: "flex text-sm basecolor-mr",
                            label: _ctx.$t('creatOutput'),
                            key: "number",
                            result: _unref(clearCreatinina),
                            unit: "ml/min"
                        }, null, 8, ["label", "result"]),
                        _createVNode(BaseButtons, {
                            hiddenSalvaButton: "",
                            onClearForm: resetForm,
                            onCalculate: calculator
                        })
                    ])
                ]),
                _hoisted_2
            ], 64));
        };
    }
});
